import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, TextField, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { MainDialogTitle } from './MainDialogTitle'
import { QRCodeSVG } from 'qrcode.react'
import { FormattedMessage, useIntl } from 'react-intl'
import { DownloadQrToPng, DownloadQrToSvg } from '../UtilsComponents/DownloadQr'
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LaunchIcon from '@mui/icons-material/Launch';
import { Link } from 'react-router-dom'
import useAxiosPrivate from '../../CustomHooks/useAxiosPrivate'
import useAuth from '../../CustomHooks/useAuth'
import { useQuery } from '@tanstack/react-query'

export const QrStoreDialog = ({ open, setOpen, storeId, storeName }) => {
    const { defaultCustomer } = useAuth();
    const intl = useIntl();
    const qrSize = 800;
    const reduceSize = 200;
    const locationUrl = `https://${window.location.host}/newsurvey/${defaultCustomer}/`;
    const axiosPrivate = useAxiosPrivate();
    const [surveys, setSurveys] = useState([]);

    const [value, setValue] = useState(null);
    const [inputValue, setInputValue] = useState('');

    const getData = async () => {
        const response = await axiosPrivate.get(`survey?customer=${defaultCustomer}`);
        return response.data;
    }
    const { data, isError } = useQuery({
        queryKey: ["surveys"],
        queryFn: getData,
        refetchOnWindowFocus: false,
        retry: false,
    });

    useEffect(() => {
        if (data) {
            const surveyOptions = data.map((survey) => ({
                label: survey.source, //or survey_name
                id: survey.id,
            }));
            setSurveys(surveyOptions);
        }
    }, [data]);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
            fullWidth={true}
            maxWidth={"xs"}
        >
            <MainDialogTitle id="responsive-dialog-title" onClose={handleClose}>
                {storeName} QR
            </MainDialogTitle>
            <DialogContent >
                <Box
                    noValidate
                    component="form"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        m: 'auto',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <h6>
                        Por favor, selecciona una encuesta para generar el QR
                    </h6>
                    {isError &&
                        <h6 style={{ color: "red", textAlign: "center" }}>
                            Hubo un error al cargar las encuestas, por favor intenta de nuevo mas tarde
                        </h6>
                    }
                    <Autocomplete
                        className='center RegularMadeTommy mt-2'
                        disablePortal
                        options={surveys}
                        sx={{ width: '100%' }}
                        value={value}
                        onChange={(event, newValue) => {
                            setValue(newValue);
                        }}
                        isOptionEqualToValue={(option, value) => option.label === value.label}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue);
                        }}
                        ListboxProps={{
                            'aria-labelledby': 'demo-dialog-autocomplete-label',
                            style: { padding: '0px 10px', maxHeight: "200px", overflowY: "auto" }
                        }}
                        renderInput={(params) =>
                            <TextField {...params} label="Encuestas" />
                        }
                    />
                    <div className='text-center mt-3' >
                        <QRCodeSVG
                            style={{ width: reduceSize, height: "auto", borderRadius: "20px" }}
                            value={`${locationUrl}${storeId}?survey=${value?.id}`}
                            includeMargin={false}
                            size={qrSize}
                            level="L"
                            id={storeId}
                            imageSettings={!value?.label && {
                                src: '/images/not image.png', //Logo de 7Bytes debe ser en base64 (data:image/svg+xml;base64) para poder descargar
                                x: undefined,
                                y: undefined,
                                height: 300,
                                width: 300,
                                excavate: true,
                                opacity: 0.6,
                            }}
                        />
                    </div>
                    {
                        value?.label &&
                        <div className='text-center mt-2'>
                            <Tooltip title={`${locationUrl}${storeId}?survey=${value.id}`} placement="bottom">
                                <span>
                                    <Link to={`${locationUrl}${storeId}?survey=${value.id}`} target="_blank" autoFocus rel="noopener noreferrer" style={{ color: "#3c8bd9" }}>
                                        <LaunchIcon sx={{ width: "17px" }} />&nbsp;
                                        <FormattedMessage
                                            id="open.survey"
                                            defaultMessage={'Abrir encuesta'}
                                        />
                                    </Link>
                                </span>
                            </Tooltip>
                            &nbsp;
                            <Tooltip title={intl.formatMessage({ id: "clickToCopy" })} placement="right">
                                <ContentCopyIcon sx={{ width: "15px", cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(`${locationUrl}${storeId}?survey=${value.id}`) }} />
                            </Tooltip>
                        </div>
                    }
                </Box>
            </DialogContent>
            {value?.label &&
                <DialogActions sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 0
                }}>
                    <Button autoFocus onClick={() => DownloadQrToSvg(storeId, storeId)}>
                        <CodeOutlinedIcon />&nbsp;
                        <FormattedMessage
                            id="download.qr.code.svg"
                            defaultMessage={'Descargar SVG'}
                        />
                    </Button>
                    <Button autoFocus onClick={() => DownloadQrToPng(storeId, storeId, qrSize)}>
                        <InsertPhotoOutlinedIcon />&nbsp;
                        <FormattedMessage
                            id="download.qr.code.png"
                            defaultMessage={'Descargar PNG'}
                        />
                    </Button>
                </DialogActions>
            }
        </Dialog>
    )
}
